
import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { randomIntegerBetween } from '@/utils/calculation'
import { NeoLoading } from '@kodadot1/brick'

@Component({ components: { NeoLoading } })
export default class Loader extends Vue {
  @Prop(String) public status!: string
  @Prop(Boolean) public value!: boolean
  @Prop({ type: Boolean, default: true }) public canCancel

  // seed new funfact each time loader is used
  @Watch('value')
  private handleLoadingStateChange(newValue) {
    if (newValue) {
      let newRandomNumber = this.randomNumber
      // make sure same quote isn't fetched again
      while (newRandomNumber === this.randomNumber) {
        newRandomNumber = randomIntegerBetween(1, 35)
      }
      this.randomNumber = newRandomNumber
    }
  }

  protected placeholder = '/preloader.svg'

  protected randomNumber = randomIntegerBetween(1, 35)

  public interval

  get randomFunFactHeading() {
    return this.$t(`funfacts.${this.randomNumber}.heading`)
  }

  get randomFunFactQuestion() {
    return this.$t(`funfacts.${this.randomNumber}.question`)
  }

  get isLoading() {
    return this.value
  }

  set isLoading(value: boolean) {
    this.$emit('input', value)
  }

  public created(): void {
    setInterval(() => {
      this.interval = this.randomNumber = randomIntegerBetween(1, 35)
    }, 8000)
  }

  public beforeDestroy() {
    clearInterval(this.interval)
  }
}
